import clsx from 'clsx'
import { Link } from 'react-router-dom'

import { PATH } from '../../../../../const'
import { Row } from '../../../pages/trade-events'
import classes from '../index.module.scss'

export interface EventListProps {
  operationId: string
  rows: Row[]
  selectedDate: Date
  source: string
  tradeId: string
}

export const EventList = ({ operationId, rows, selectedDate, source, tradeId }: EventListProps) => (
  <ul className={classes.list}>
    {rows.map(row => (
      <li key={row.id} className={clsx({ [classes.active]: row.id === operationId })}>
        <Link to={PATH.reportsSingleTradeEventsEvent(source, tradeId, selectedDate, row.id)}>
          {row.readableType}
        </Link>
      </li>
    ))}
  </ul>
)
